<div class="rfid-reader">
  <sc-padding>
    <form class="form" [formGroup]="formGroup">
      <mat-form-field appearance="outline" appearance="fill">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.yard-simulator.rfid-reader"></sc-dictionary-label>
        </mat-label>
        <mat-select (valueChange)="onCameraSelection($event)">
          @for (rfid of rfids; track rfid) {
            <mat-option [value]="rfid">
              {{ rfid.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <sc-flex vertical stretchContent>
        <sc-string-field formControlName="scannedNumber" labelDictionaryKey="tmc-yard.ui.admin.yard-simulator.rfid-protocol">
        </sc-string-field>
      </sc-flex>
    </form>

    <sc-button dictionaryKey="tmc-yard.ui.admin.yard-simulator.send" primary  class="config-changed-button" (click)="onButtonTrigger()"
    [disabled]="!scannedNumber || !rfidSelected"></sc-button>
  </sc-padding>
</div>
